import { GET_ERRORS,GET_ERRORS2 } from '../actions/types';

const initialState = {};

export default function(state = initialState,action=undefined){
    switch(action.type){
        case GET_ERRORS:
            return action.payload
            case GET_ERRORS2:
                return action.payload
        default:    
            return state;   
    }
}